import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button as ButtonMui} from "@mui/material";
import {Box} from "grommet";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DeleteIcon from "@mui/icons-material/Delete";
import {colors} from "../../utilis/theme.js";

const config = {
  warning: {icon: WarningAmberIcon, color: '#ed6c02', confirmColor: '#ed6c02'},
  delete: {icon: DeleteIcon, color: colors.error, confirmColor: colors.error},
};

export default function ConfirmDialog({open, onClose, onConfirm, message, type = "warning", confirmLabel = "Conferma", cancelLabel = "Annulla"}) {
  const {icon: Icon, color, confirmColor} = config[type] || config.warning;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {borderRadius: '16px', minWidth: '380px', overflow: 'hidden'}
      }}
    >
      <DialogContent sx={{textAlign: 'center', pt: 4, pb: 2}}>
        <Box style={{
          width: 64, height: 64, borderRadius: '50%',
          backgroundColor: `${color}14`, display: 'flex',
          alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px'
        }}>
          <Icon sx={{fontSize: 32, color: color}} />
        </Box>
        <Box style={{fontSize: '16px', fontWeight: 500, color: colors.textPrimary}}>
          {message}
        </Box>
      </DialogContent>
      <DialogActions sx={{justifyContent: 'center', pb: 3, gap: 1}}>
        <ButtonMui
          variant="outlined"
          onClick={onClose}
          sx={{borderRadius: '8px', textTransform: 'none', minWidth: '100px'}}
        >
          {cancelLabel}
        </ButtonMui>
        <ButtonMui
          variant="contained"
          onClick={() => { onConfirm(); onClose(); }}
          sx={{
            borderRadius: '8px', textTransform: 'none', minWidth: '100px',
            backgroundColor: confirmColor,
            '&:hover': {backgroundColor: confirmColor, filter: 'brightness(0.9)'}
          }}
        >
          {confirmLabel}
        </ButtonMui>
      </DialogActions>
    </Dialog>
  );
}
